import * as React from 'react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { surveyHelper } from '../amorg-common';
import { LoadingPageOverlay } from '../designSystem/LoadingPageOverlay';
import { PublicLinkSurveyReport } from '../amorg-common';
import { SurveyReportPanel } from '../features/surveys/report/SurveyReportPanel';
import { H1, H2 } from '../designSystem/typography/Heading';
import { NoNavigationPageWrapper } from '../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { getSurveyReportFromLinkId } from '../api/surveyClientApi';
import { Flex } from '../designSystem/compositeComponents/FlexHelpers';
import { ToolBarButton, ToolBarContainer } from '../designSystem/compositeComponents/ButtonToolBar';
import { Divider } from '../designSystem/Divider';
import { useReactToPrint } from 'react-to-print';
import PrintSurveyReportPage from './PrintSurveyReportPage';
import { PageHeader } from '../designSystem/PageHeader';
import { SingleColumnLayout } from '../designSystem/layouts/SingleColumnLayout';
import { PublicPageProvider } from './_contexts/PublicPageContext';
import { ReadOnlySegmentPanel } from '../features/surveys/segmentation/ReadOnlySegmentPanel';


type PageState = {
    publicReport: PublicLinkSurveyReport,
    loading: boolean
};
export function SurveyReportPublicPage(): JSX.Element {

    const params = useParams<{ siteId: string, linkId: string }>();

    const [state, setState] = useState<PageState>({
        publicReport: null,
        loading: true
    });

    useEffect(() => {
        const getData = async () => {
            const publicReport = await getSurveyReportFromLinkId(params.siteId, params.linkId);
            const newState = {
                publicReport,
                loading: false
            };
            setState(newState);
        };
        getData();
    }, []);

    const hasQuestions = !state.loading && state.publicReport && surveyHelper.getAllSurveyQuestions(state.publicReport.survey).length > 0;

    const printRef = React.useRef(null);
    const printFn = useReactToPrint({
        contentRef: printRef,
        documentTitle: "Rapport"
    });

    return (
        <PublicPageProvider>
        <NoNavigationPageWrapper>

            <SingleColumnLayout
                noDivider
                headerContainer={
                    <>
                        {state.loading &&
                            <LoadingPageOverlay loading={state.loading} />
                        }

                        {!state.loading && state.publicReport &&
                            <>
                            <PageHeader headerStyle='primary-black'
                                headerContentsOverride={
                                    <div>
                                        <H1 color="gray">Rapport</H1>
                                        <H2>{state.publicReport.survey.title}</H2>
                                    </div>
                                }
                                buttons={
                                    <ToolBarContainer>
                                        <ToolBarButton
                                            icon='interface_actions_print'
                                            tooltip= 'Print'
                                            variant= 'text'
                                            onClick={printFn} />

                                        <PrintSurveyReportPage
                                            survey={state.publicReport.survey}
                                            questionStats={state.publicReport.questionStats}
                                            segmentFilter={state.publicReport.segmentFilter}
                                            innerRef={printRef} />
                                    </ToolBarContainer>
                                } />
                            </>
                        }
                    </>
                    
                }

                contentContainer={
                    <>
                    <Flex flexDirection='column' gap={16}>
                        {!state.loading && state.publicReport === null &&
                            <p>Det valgte link er ugyldigt, eller ikke længere tilgængeligt. Kontakt din arbejdsmiljøgruppe.</p>
                        }
                        {!state.loading && state.publicReport && hasQuestions &&
                        <Flex flexDirection='column' gap={16}>
                            <H2>Segmenter</H2>
                            <ReadOnlySegmentPanel segmentLists={state.publicReport.segmentFilter} lockedView='pills' />
                        </Flex>
                        }
                    </Flex>
                    
                    <Divider />

                    <Flex flexDirection='column' gap={16}>

                        {state.loading &&
                            <LoadingPageOverlay loading={state.loading} />
                        }
                        {!state.loading && state.publicReport && !hasQuestions &&
                            <p>Spørgeskemaet indeholder ikke spørgsmål</p>
                        }

                        {!state.loading && state.publicReport && hasQuestions &&
                            <>
                                <SurveyReportPanel
                                    siteId={params.siteId}
                                    survey={state.publicReport.survey}
                                    questionStats={state.publicReport.questionStats}
                                    segmentFilter={state.publicReport.segmentFilter}
                                    showComments={false} />
                            </>
                        }

                    </Flex>
                    </>
                } />

        </NoNavigationPageWrapper>
        </PublicPageProvider>
    );
}